		/* eslint no-underscore-dangle:
			["error", { "allow": ["_howls", "_sounds", "_ended", "_codecs"] }]
		*/
import { Howler } from 'howler';
import { randomValue } from '@/mixins/random';
import { getSoundVolume, createHowl } from '@/mixins/sound-fx';

// automatically resume howler if audiocontext is stopped by browser after refresh
if ('ctx' in Howler && Howler.ctx !== null) {
	Howler.ctx.resume();
}

let fileType = "mp3";
fileType = Howler._codecs.webm ? "webm" : fileType;

export default {
	state: {
		fileType,
		muted: false,
		tracks: {},
		nowPlaying: null,
		nowPlayingFilename: "",
	},
	actions: {
		registerSound(context, payload) {
			const howl = payload.howl;
			const name = payload.name;

			howl.once("play", () => {
				context.commit("addTrack", { howl, name });
			});
			howl.once("end", () => {
				context.commit("removeTrack", { howl, name });
			});
			howl.once("stop", () => {
				context.commit("removeTrack", { howl, name });
			});
		},
		transitionMusic(context, payload) {
			context.commit("activateMusicTransition", payload);
			context.state.nowPlaying.once("stop", () => {
				context.commit("unloadNowPlaying");
				context.commit("setNowPlaying", payload);
			});
		},
		playSwoosh(context) {
			const sound = randomValue(context.rootState.config.sounds.swooshes.fx_group);
			const volume = getSoundVolume(sound);
			const swoosh = createHowl(sound.url, { volume });
			swoosh.play();
		},
		playDeadCatFx(context) {
			let fxName = "death_single";
			fxName = context.rootState.cats.unfedCount === 2 ? "death_couple" : fxName;
			fxName = context.rootState.cats.unfedCount >= 5 ? "death_few" : fxName;
			fxName = context.rootState.cats.unfedCount >= 8 ? "death_many" : fxName;

			const sound = randomValue(context.rootState.config.sounds[fxName].fx_group);
			const volume = getSoundVolume(sound);
			const deathFx = createHowl(sound.url, { volume });

			deathFx.play();
		},
		pauseAllSounds() {
			Howler._howls.forEach((howl) => {
				howl._sounds.forEach((sound) => {
					if (!sound._ended) {
						howl.pause();
					}
				});
			});
		},
		unpauseAllSounds() {
			Howler._howls.forEach((howl) => {
				howl._sounds.forEach((sound) => {
					if (!sound._ended) {
						howl.play();
					}
				});
			});
		},
	},
	mutations: {
		toggleMute(state) {
			Howler.mute(!state.muted);
			state.muted = !state.muted;
		},
		unloadNowPlaying(state) {
			state.nowPlaying.stop();
			state.nowPlaying.unload();
		},
		setNowPlaying(state, payload) {
			state.nowPlaying = payload.music;
			state.nowPlayingFilename = payload.music[0];
		},
		activateMusicTransition(state, payload) {
			payload.stinger.on("play", () => {
				state.nowPlaying.volume(0);
				state.nowPlaying.stop();
			});

			payload.stinger.on("end", () => {
				payload.music.play();
			});

			payload.stinger.play();
		},
		addTrack(state, payload) {
			if (payload.name in state.tracks === false) {
				state.tracks[payload.name] = [];
			}
			state.tracks[payload.name].push(payload.howl);
		},
		removeTrack(state, payload) {
			const trackIndex = state.tracks[payload.name].findIndex(track => track === payload.howl);
			state.tracks[payload.name][trackIndex].unload();
			state.tracks[payload.name].splice(trackIndex, 1);
		},
	},
	getters: {
		alreadyPlayingMusic(state) {
			return url => state.nowPlayingFilename === url;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/sound.js